// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import { useState } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material"
import { alpha } from "@mui/material/styles"
import { CheckCircle2, UserPlus } from "lucide-react"
import { ContactFormModal } from "@crm-src/components/contact-form-modal"

interface AddContactsAfterCreationModalProps {
  isOpen: boolean
  onClose: () => void
  entityId: string
  entityName: string
  entityType: "customer" | "prospect"
}

export function AddContactsAfterCreationModal({
  isOpen,
  onClose,
  entityId,
  entityName,
  entityType
}: AddContactsAfterCreationModalProps) {
  const [showContactForm, setShowContactForm] = useState(false)
  const [showSuccessPrompt, setShowSuccessPrompt] = useState(true)

  const handleSkip = () => {
    setShowSuccessPrompt(true)
    setShowContactForm(false)
    onClose()
  }

  const handleYesAddContacts = () => {
    setShowSuccessPrompt(false)
    setShowContactForm(true)
  }

  const handleContactSaved = () => {
    // Contact was saved, user can add another or close
    // Keep the contact form open so they can add more
  }

  const handleContactFormClose = () => {
    setShowContactForm(false)
    setShowSuccessPrompt(true)
    onClose()
  }

  return (
    <>
      {/* Success Prompt Dialog */}
      <Dialog open={isOpen && showSuccessPrompt} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ textAlign: "center", pt: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                bgcolor: (t) => alpha(t.palette.success.main, 0.12),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "success.main",
              }}
            >
              <CheckCircle2 size={40} />
            </Box>
          </Box>
          <Typography variant="h5" component="div" sx={{ fontWeight: 600 }}>
            {entityType === "customer" ? "Customer" : "Prospect"} Created Successfully!
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ textAlign: "center", pt: 1 }}>
            <Box component="span" sx={{ fontWeight: 500, color: "text.primary" }}>{entityName}</Box> has been added to your CRM.
            <br />
            <br />
            Would you like to add contact person(s) for this {entityType}?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 1, pb: 3 }}>
          <Button variant="outlined" color="inherit" onClick={handleSkip}>
            Skip for Now
          </Button>
          <Button variant="contained" onClick={handleYesAddContacts} startIcon={<UserPlus size={16} />}>
            Yes, Add Contacts
          </Button>
        </DialogActions>
      </Dialog>

      {/* Contact Form Modal - Reusable component */}
      {showContactForm && (
        <ContactFormModal
          isOpen={showContactForm}
          onClose={handleContactFormClose}
          customerId={entityId}
          onContactSaved={handleContactSaved}
        />
      )}
    </>
  )
}
